export class inspirationalMessage {
  public id?: number;
  public dbRowVersion?: string;
  public message?: string;
  public isActive?: boolean;
}
